import { IContract } from '@/interfaces';
import { ContractState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
    setContracts(state: ContractState, payload: IContract[]) {
        state.contracts = payload;
    },
    setContract(state: ContractState, payload: IContract) {
        const contracts = state.contracts.filter((contract: IContract) => contract.key1 !== payload.key1);
        contracts.push(payload);
        state.contracts = contracts;
    },
};

const { commit } = getStoreAccessors<ContractState, State>('');

export const commitSetContract = commit(mutations.setContract);
export const commitSetContracts = commit(mutations.setContracts);
